import { PortalOnboardingType } from '../../../services/tenantHandler/strategy/external-types';
import TenantHandlerInterfaceV1 from './TenantHandlerInterfaceV1';
import * as T from '@clientos/types';
import { AuthContextEnum } from '../../../services/authTokenService';
import { internalLogger } from '../clientOsLogger';

let tenantHandlerInterfaceV1: T.TenantHandlerInterfaceType;

export default async function initializeTenantHandlerInterfaceSingleton(): Promise<T.TenantHandlerInterfaceType> {
  if (tenantHandlerInterfaceV1) return tenantHandlerInterfaceV1;

  tenantHandlerInterfaceV1 = new TenantHandlerInterfaceV1();

  return tenantHandlerInterfaceV1;
}

export function createNoopTenantHandlerInterface(): T.TenantHandlerInterfaceType {
  return {
    isEnabled: function (): boolean {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'CreateNoopTenantHandlerInterface',
        methodName: 'isEnabled',
        message: 'Function not implemented.'
      });
      return false;
    },
    getCurrentContext: function (): AuthContextEnum {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'CreateNoopTenantHandlerInterface',
        methodName: 'getCurrentContext',
        message: 'Function not implemented.'
      });
      return AuthContextEnum.tenantless;
    },
    getTenantData: function (): T.TenantVisualizationType {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'CreateNoopTenantHandlerInterface',
        methodName: 'getTenantData',
        message: 'Function not implemented.'
      });
      return { id: '1', name: '' };
    },
    getTenantId: function (): string {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'CreateNoopTenantHandlerInterface',
        methodName: 'getTenantId',
        message: 'Function not implemented.'
      });
      return '';
    },
    setTenant: function (): Promise<boolean> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'CreateNoopTenantHandlerInterface',
        methodName: 'setTenant',
        message: 'Function not implemented.'
      });
      return Promise.resolve(true);
    },
    getTenantById: function (): Promise<T.TenantVisualizationType> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'CreateNoopTenantHandlerInterface',
        methodName: 'getTenantById',
        message: 'Function not implemented.'
      });
      return Promise.resolve({ id: '1', name: '' });
    },
    getTenantList: function (): Promise<T.TenantVisualizationType[]> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'CreateNoopTenantHandlerInterface',
        methodName: 'getTenantList',
        message: 'Function not implemented.'
      });
      return Promise.resolve([]);
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getPaginatedTenantList: function (): Promise<any> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'CreateNoopTenantHandlerInterface',
        methodName: 'getPaginatedTenantList',
        message: 'Function not implemented.'
      });
      return Promise.resolve();
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getNextUnproccessedTenant: function (): any {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'CreateNoopTenantHandlerInterface',
        methodName: 'getNextUnproccessedTenant',
        message: 'Function not implemented.'
      });
      return {};
    },
    onTenantChange: function (): () => void {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'CreateNoopTenantHandlerInterface',
        methodName: 'onTenantChange',
        message: 'Function not implemented.'
      });
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      return () => {};
    },
    getPortalOnboardingList: function (): PortalOnboardingType[] {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'CreateNoopTenantHandlerInterface',
        methodName: 'getPortalOnboardingList',
        message: 'Function not implemented.'
      });
      return [];
    },
    useReactGetTenantList: function (): T.UseReactGetTenantListResponseType {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'CreateNoopTenantHandlerInterface',
        methodName: 'useReactGetTenantList',
        message: 'Function not implemented.'
      });
      return {
        loading: false,
        reload: async () => {},
        data: [],
        error: null
      };
    }
  };
}
